import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// 页面路由引入
import Home from '@/components/Home'
import Index from '@/components/section/index'
import Aboutus from '@/components/section/aboutus'

// 404页
import Errorinfo from '@/components/error/404'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: '/web/',
  routes: [
    {
      path: '/',
      redirect: '/home/index'
    },
    {
      path: '/home',
      redirect: '/home/index',
      name: 'home',
      component: Home,
      children: [
        {
          path: '/home/index',
          name: 'index',
          component: Index,
          // meta: {
          //   title: "托乐乐-云端助教-安全可靠的大学生网络兼职",
          //   content: "兼职；赚钱；大学生；在线；家教；批改；作业；助教；实习；找工作"
          // }
        },
        {
          path: '/home/aboutus',
          name: 'aboutus',
          component: Aboutus,
          // meta: {
          //   title: "托乐乐-云端助教-大学生靠谱在线兼职平台",
          //   content: "兼职；赚钱；大学生；助教；实习；在家；在线；家教；薪资；提现；"
          // }
        }
      ]
    },
    // 404page
    // {
    //   path: '/errorinfo',
    //   name: 'errorinfo',
    //   component: Errorinfo
    // }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   return {
  //     x: 0,
  //     y: 0
  //   }
  // },
  // history: true
})

// 路由错误跳转首页
router.beforeEach((to, from, next) => {
  // 路由发生改变修改页面
  // if (to.meta.content) {
  //   let head = document.getElementsByTagName('head');
  //   let meta = document.createElement('meta');
  //   meta.name = "description";
  //   meta.name = "Keywords";
  //   meta.content = to.meta.content;
  //   head[0].appendChild(meta);
  // }

  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }

  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/home/index');
  }
  next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js